import { Select } from '@chakra-ui/react';
import {
  QuotePdfType,
  quotePdfTypeMetadata,
  SiteCode,
} from '@snap-types/models/enums';
import { SnapSiteConfigEditFormDataUnvalidated } from '@snap-types/models/snap-site-config';
import { UpdateTeamWithConfig } from '@snap-types/models/team';
import { objectKeysTyped } from '@snap-types/util/object-iterators';
import { useFormContext } from 'react-hook-form';

export function TeamQuotePdfSelect({
  team,
  index,
}: {
  team: UpdateTeamWithConfig;
  index: number;
}) {
  const form = useFormContext<SnapSiteConfigEditFormDataUnvalidated>();

  const pdfOptions = objectKeysTyped(QuotePdfType)
    .map((pdfType) => {
      if (
        quotePdfTypeMetadata[pdfType].limitedToSites === null ||
        quotePdfTypeMetadata[pdfType].limitedToSites?.includes(
          form.getValues('site.code') as SiteCode,
        )
      ) {
        return {
          pdfType,
          ...quotePdfTypeMetadata[pdfType],
        };
      }
      return null;
    })
    .filter((pdfType) => pdfType !== null);

  return (
    <Select
      id={`${team.teamCode}-PDFType_intput`}
      {...form.register(`site.teams.${index}.currentTeamConfig.quotePdfType`)}
    >
      {pdfOptions.map((pdfType) => (
        <option key={pdfType.pdfType} value={pdfType.pdfType}>
          {pdfType.name}
        </option>
      ))}
    </Select>
  );
}
